<!-- <app-header position="fixed-top" [showBackButton]="true"></app-header>
  -->
<banner-app [Fixtop]="''" [retroSelected]="false" [infoDueno]="true"  [showPromo]="true"></banner-app>
<section class="resume-container py-5">
  <div class="pt-5 py-lg-5 container">
    <div class="row justify-content-center me-0">
      <div class="col-12 col-md-8 col-lg-6 d-flex flex-column align-items-center text-center">
        <h2 class="resume-title mb-4 mt-5">¡Ya tienes una cotización en curso!</h2>
        <p class="resume-subtitle mb-5">Encontramos una cotización de tu Seguro <span>de arriendo que ya habías iniciado.</span></p>

        <img
          class="resume-image"
          src="./assets/img/Mesa-de-trabajo.png"
          priority
          alt="Ilustración de dos manos estrechándose en señal de acuerdo."
        />

        <!-- <button type="button" class="btn btn-primary btn-lg rounded-pill sura-resume-btn mt-lg-0 mt-3 mb-3" (click)="goBack()">
                    Seguir en línea
                </button> -->
        <button type="button" class="btn btn-primary btn-lg rounded-pill resume-btn mt-lg-0 mt-3 mb-5" (click)="handleClick()">
          Continuar cotización
        </button>
      </div>
    </div>
  </div>
</section>

<app-footer-app class="footer-fixed" />
